<div class="border-b border-gray-100 last:border-b-0">
    <button class="w-full flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition-colors "
        [class.bg-blue-50]="isTouched" (click)="clickExpand()">
        <div class="w-10 h-10 text-base rounded-full flex items-center justify-center text-white font-bold flex-shrink-0 "
            [ngStyle]="{'background-color': backgroundColor}">
            {{firstLetter}}</div>
        <div class="flex-1 text-left">
            <p class="font-medium text-gray-900">{{name}}</p>
        </div>
        <ng-container [ngSwitch]="true">
            <ng-container *ngSwitchCase="isSubmitted.value">
                <span class="text-xs bg-green-600 text-white px-2 py-1 rounded-full flex items-center gap-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-check w-3 h-3">
                        <path d="M20 6 9 17l-5-5"></path>
                    </svg>保存済み
                </span>
            </ng-container>
            <ng-container *ngSwitchCase="!isSubmitted.value && isTouched">
                <span class="text-xs bg-blue-600 text-white px-2 py-1 rounded-full" *ngIf="isTouched">入力済み</span>
            </ng-container>
        </ng-container>
        <app-dropdown-arrow [expanded]="expanded"></app-dropdown-arrow>
    </button>
    <!-- create notes -->
    <div class="dropdown-list w-full" [class.expanded]="expanded">
        <ng-container *ngIf="expanded">
            <ng-container *ngIf="!isSubmitted.value; else submittedCover">
                <ng-container *ngFor="let record of records; let i = index">
                    <div class="m-5">
                        <app-record-field [record]="record" [form]="getRecordForm(i)"></app-record-field>
                    </div>
                </ng-container>
                <!-- <div class="flex gap-2 pt-2">
                    <button (click)="onSubmit()"
                        class="flex-1 bg-blue-600 text-white rounded-lg py-2.5 text-sm font-medium hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"><svg
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-save w-4 h-4">
                            <path
                                d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z">
                            </path>
                            <path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7"></path>
                            <path d="M7 3v4a1 1 0 0 0 1 1h7"></path>
                        </svg>保存</button>
                    <button *ngIf="!isSameAsOriginal" (click)="resetForm()"
                        class="px-4 bg-gray-200 text-gray-700 rounded-lg py-2.5 text-sm font-medium hover:bg-gray-300 transition-colors"><svg
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-x w-4 h-4">
                            <path d="M18 6 6 18"></path>
                            <path d="m6 6 12 12"></path>
                        </svg></button>
                </div> -->
            </ng-container>
        </ng-container>
    </div>
    <!-- <div class="dropdown-list w-full" [class.expanded]="expanded">
        <ng-container *ngIf="expanded">
            <ng-container *ngIf="!isSubmitted.value; else submittedCover">
                <app-record-create-form [form]="record"></app-record-create-form>
                <div class="flex gap-2 pt-2">
                    <button (click)="onSubmit()"
                        class="flex-1 bg-blue-600 text-white rounded-lg py-2.5 text-sm font-medium hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"><svg
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-save w-4 h-4">
                            <path
                                d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z">
                            </path>
                            <path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7"></path>
                            <path d="M7 3v4a1 1 0 0 0 1 1h7"></path>
                        </svg>保存</button>
                    <button *ngIf="!isSameAsOriginal" (click)="resetForm()"
                        class="px-4 bg-gray-200 text-gray-700 rounded-lg py-2.5 text-sm font-medium hover:bg-gray-300 transition-colors"><svg
                            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-x w-4 h-4">
                            <path d="M18 6 6 18"></path>
                            <path d="m6 6 12 12"></path>
                        </svg></button>
                </div>
            </ng-container>

        </ng-container>
    </div> -->
</div>

<!-- template submitted -->
<ng-template #submittedCover>
    <div class="bg-green-50 border-2 border-green-200 rounded-xl p-6 text-center">
        <div class="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3"><svg
                xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-check w-6 h-6 text-green-600">
                <path d="M20 6 9 17l-5-5"></path>
            </svg></div>
        <p class="font-medium text-green-900 mb-1">保存済み</p>
        <p class="text-sm text-green-700 mb-4">この記録は既に保存されています</p>
        <button class="text-sm text-green-700 hover:text-green-800 font-medium underline"
            (click)="editForm()">編集する</button>
    </div>
</ng-template>